<template>
  <div class="modal" :class="{ 'is-active': show }">
    <div class="modal-background" @click="closeModal"></div>

    <div class="modal-card relacion-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Crear Relación</p>
        <button class="delete" @click="closeModal" aria-label="Cerrar" />
      </header>

      <section class="modal-card-body relacion-body">
        <div class="columns is-variable is-4" style="height: 100%;">
          <div class="column is-7 relacion-left-col">
            <b-field>
              <b-input
                v-model="search"
                placeholder="Buscar por nombre o correo"
                icon="magnify"
                :icon-right="search ? 'close-circle' : ''"
                icon-right-clickable
                :loading="initialLoading"
                @icon-right-click="clearSearch"
              />
            </b-field>

            <div class="relacion-counter">
              <span v-if="!initialLoading && pagination.count > 0">
                <strong>{{ pagination.count }}</strong> empleado{{
                  pagination.count !== 1 ? "s" : ""
                }}
                encontrado{{ pagination.count !== 1 ? "s" : "" }}
              </span>
              <span
                v-if="!initialLoading && pagination.count === 0"
                class="has-text-grey"
                >Sin resultados</span
              >
            </div>

            <div class="relacion-table-wrapper" ref="relacionTableWrapper">
              <b-table
                :data="employees"
                :loading="initialLoading"
                narrowed
                hoverable
                striped
                mobile-cards
                :row-class="(row) => getRowClass(row)"
              >
                <b-table-column
                  field="index"
                  label="#"
                  width="40"
                  v-slot="props"
                >
                  <span class="has-text-grey is-size-7">
                    {{ props.index + 1 }}
                  </span>
                </b-table-column>

                <b-table-column field="nombre" label="Empleado" v-slot="props">
                  <div class="relacion-employee-cell">
                    <div class="relacion-avatar">
                      {{ initials(props.row.nombre) }}
                    </div>
                    <div>
                      <p class="relacion-employee-name">
                        {{ props.row.nombre }}
                      </p>
                      <p class="relacion-employee-cargo">
                        {{ props.row.cargo }}
                      </p>
                    </div>
                  </div>
                </b-table-column>

                <b-table-column label="Asignar" width="200" v-slot="props">
                  <div class="buttons are-small">
                    <b-button
                      size="is-small"
                      :type="
                        evaluated._id === props.row._id
                          ? 'is-success'
                          : 'is-light'
                      "
                      :icon-left="
                        evaluated._id === props.row._id ? 'check' : 'account'
                      "
                      @click="evalutedEmployeeSelected(props.row)"
                      >Evaluado</b-button
                    >
                    <b-button
                      size="is-small"
                      :type="isEvaluator(props.row) ? 'is-info' : 'is-light'"
                      :icon-left="
                        isEvaluator(props.row) ? 'check' : 'account-multiple'
                      "
                      @click="evaluatorEmployeeSelected(props.row)"
                      >Evaluador</b-button
                    >
                  </div>
                </b-table-column>

                <template #empty>
                  <div class="relacion-empty">
                    <b-icon
                      icon="account-search"
                      size="is-large"
                      type="is-grey-light"
                    />
                    <p class="has-text-grey">No se encontraron empleados</p>
                  </div>
                </template>
              </b-table>

              <div ref="loadMoreSentinel" class="relacion-load-more">
                <span v-if="isLoadingMore" class="has-text-grey is-size-7"
                  >Cargando más…</span
                >
              </div>
            </div>
          </div>

          <div class="column is-5 relacion-right-col">
            <div
              class="relacion-selection-card"
              :class="{ 'has-selection': evaluated._id }"
            >
              <div class="relacion-selection-header">
                <b-icon icon="account" size="is-small" />
                <span>Evaluado</span>
              </div>

              <div v-if="evaluated._id" class="relacion-selected-employee">
                <div class="relacion-avatar is-large">
                  {{ initials(evaluated.nombre) }}
                </div>
                <div class="relacion-selected-info">
                  <p class="relacion-employee-name">{{ evaluated.nombre }}</p>
                  <p class="relacion-employee-cargo">{{ evaluated.cargo }}</p>
                  <p class="relacion-employee-email">{{ evaluated.email }}</p>
                </div>
                <button
                  class="delete is-small relacion-remove-btn"
                  @click="clearEvaluated"
                />
              </div>

              <div v-else class="relacion-empty-slot">
                <b-icon icon="account-plus-outline" type="is-grey-light" />
                <span class="has-text-grey is-size-7"
                  >Ninguno seleccionado</span
                >
              </div>
            </div>

            <div
              class="relacion-selection-card"
              :class="{ 'has-selection': evaluator.length > 0 }"
            >
              <div class="relacion-selection-header">
                <b-icon icon="account-multiple" size="is-small" />
                <span>Evaluadores</span>
                <b-tag v-if="evaluator.length" type="is-dark" rounded>{{
                  evaluator.length
                }}</b-tag>
              </div>

              <div v-if="evaluator.length" class="relacion-evaluators-list">
                <div
                  v-for="(e, i) in evaluator"
                  :key="i"
                  class="relacion-selected-employee is-compact"
                >
                  <div class="relacion-avatar">{{ initials(e.nombre) }}</div>
                  <div class="relacion-selected-info">
                    <p class="relacion-employee-name">{{ e.nombre }}</p>
                    <p class="relacion-employee-cargo">{{ e.cargo }}</p>
                  </div>
                  <button
                    class="delete is-small relacion-remove-btn"
                    @click="removeEvaluator(i)"
                  />
                </div>
              </div>

              <div v-else class="relacion-empty-slot">
                <b-icon
                  icon="account-multiple-plus-outline"
                  type="is-grey-light"
                />
                <span class="has-text-grey is-size-7"
                  >Ninguno seleccionado</span
                >
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot relacion-footer">
        <b-button @click="closeModal">Cancelar</b-button>
        <b-button type="is-dark" :disabled="!canCreate" @click="crear"
          >Crear</b-button
        >
        <p v-if="!canCreate" class="relacion-hint has-text-grey is-size-7">
          <b-icon icon="information-outline" size="is-small" />
          Selecciona al menos un evaluado y un evaluador para continuar
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

const DEBOUNCE_MS = 350;

export default {
  name: "CrearRelacion",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    proceso: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      search: "",
      employees: [],
      pagination: {
        count: 0,
      },
      initialLoading: false,
      isLoadingMore: false,
      evaluator: [],
      evaluated: {},
    };
  },

  computed: {
    canCreate() {
      return !!this.evaluated._id && this.evaluator.length > 0;
    },
  },

  watch: {
    search() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.find();
      }, DEBOUNCE_MS);
    },

    show(val) {
      if (val) {
        this.resetSelection();
        this.find();
      }
    },
  },

  methods: {
    initials(nombre = "") {
      return nombre
        .split(" ")
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();
    },

    isEvaluator(employee) {
      return this.evaluator.some((e) => e._id === employee._id);
    },

    getRowClass(row) {
      if (this.evaluated._id === row._id) return "relacion-row-evaluated";
      if (this.isEvaluator(row)) return "relacion-row-evaluator";
      return "";
    },

    async find() {
      this.initialLoading = true;
      try {
        const result = await apiServices.post(
          `/searchemployee/${this.proceso._id}`,
          {
            search: this.search,
            inicial: 0,
          },
        );
        this.employees = result.data.data;
        this.pagination.count = result.data.count;
      } catch (error) {
        console.error("Error buscando empleados:", error);
        this.employees = [];
        this.pagination.count = 0;
      } finally {
        this.initialLoading = false;
      }
    },

    async loadMore() {
      if (this.isLoadingMore || this.employees.length >= this.pagination.count) {
        return;
      }
      this.isLoadingMore = true;
      try {
        const result = await apiServices.post(
          `/searchemployee/${this.proceso._id}`,
          {
            search: this.search,
            inicial: this.employees.length,
          },
        );
        this.employees.push(...result.data.data);
        this.pagination.count = result.data.count;
      } catch (error) {
        console.error("Error cargando más empleados:", error);
      } finally {
        this.isLoadingMore = false;
      }
    },

    initLoadMoreObserver() {
      this.$nextTick(() => {
        const sentinel = this.$refs.loadMoreSentinel;
        const root = this.$refs.relacionTableWrapper;
        if (!sentinel || !root || this._loadMoreObserver) return;
        this._loadMoreObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && this.show) {
              this.loadMore();
            }
          },
          { root, threshold: 0 },
        );
        this._loadMoreObserver.observe(sentinel);
      });
    },

    clearSearch() {
      this.search = "";
    },

    evalutedEmployeeSelected(employee) {
      this.evaluated = employee;
      this.$emit("evaluatedEmployee", employee);
    },

    evaluatorEmployeeSelected(employee) {
      const idx = this.evaluator.findIndex((e) => e._id === employee._id);
      if (idx > -1) {
        this.evaluator.splice(idx, 1);
      } else {
        this.evaluator.push(employee);
      }
    },

    clearEvaluated() {
      this.evaluated = {};
    },

    removeEvaluator(index) {
      this.evaluator.splice(index, 1);
    },

    resetSelection() {
      this.evaluator = [];
      this.evaluated = {};
      this.search = "";
    },

    async crear() {
      this.$emit("evaluatorEmployee", this.evaluator);
      await this.$emit("createRelation");
      this.resetSelection();
      this.closeModal();
    },

    closeModal() {
      this.$emit("showModalEmployee");
    },
  },

  created() {
    this.debounceTimer = null;
    this.find();
  },

  mounted() {
    this.initLoadMoreObserver();
  },

  beforeDestroy() {
    if (this._loadMoreObserver) this._loadMoreObserver.disconnect();
  },
};
</script>

<style lang="scss">
$border-radius: 6px;
$card-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
$avatar-bg: #363636;
$evaluated-color: #48c78e;
$evaluator-color: #3e8ed0;

.relacion-modal-card {
  width: 90vw !important;
  max-width: 1100px !important;
  height: 92vh !important;
  max-height: 820px !important;
  display: flex;
  flex-direction: column;
  border-radius: $border-radius !important;
  overflow: hidden;
}

.modal-card-body.relacion-body {
  flex: 1;
  overflow: hidden;
  padding: 1.25rem 1.5rem;
  background: #fff;

  > .columns {
    height: 100%;
    margin: 0;
  }
}

.relacion-left-col {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  height: 100%;
  overflow: hidden;

  .field {
    margin-bottom: 0;
  }
}

.relacion-counter {
  font-size: 0.78rem;
  color: #777;
  min-height: 1.1rem;
  padding-left: 0.1rem;
}

.relacion-table-wrapper {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #ededed;
  border-radius: $border-radius;
  background: #fff;

  tr.relacion-row-evaluated > td {
    background: #f0fdf6 !important;
  }
  tr.relacion-row-evaluator > td {
    background: #eff6ff !important;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
}

.relacion-load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.25rem;
  padding: 0.4rem 0;
}

.relacion-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $avatar-bg;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.3px;

  &.is-large {
    width: 42px;
    height: 42px;
    font-size: 0.85rem;
  }
}

.relacion-employee-cell {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.relacion-employee-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: #2d2d2d;
  line-height: 1.2;
  margin: 0;
}

.relacion-employee-cargo {
  font-size: 0.76rem;
  color: #888;
  margin: 0;
}

.relacion-employee-email {
  font-size: 0.72rem;
  color: #aaa;
  margin: 0.1rem 0 0;
}

.relacion-empty {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}

.relacion-right-col {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  height: 100%;
  overflow: hidden;
}

.relacion-selection-card {
  background: #fff;
  border-radius: $border-radius;
  box-shadow: $card-shadow;
  border: 1px solid #ededed;
  padding: 0.85rem 1rem;
  transition: border-color 0.2s ease;
  overflow: hidden;

  &.has-selection {
    border-color: #b5b5b5;
  }

  &:nth-child(2) {
    flex: 1;
    overflow-y: auto;
  }
}

.relacion-selection-header {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #4a4a4a;
  margin-bottom: 0.75rem;

  .icon {
    color: #b5b5b5;
  }
  .tag {
    margin-left: auto;
  }
}

.relacion-selected-employee {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.45rem 0.5rem;
  border-radius: $border-radius;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  position: relative;

  &.is-compact {
    margin-bottom: 0.4rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.relacion-selected-info {
  flex: 1;
  min-width: 0;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.relacion-remove-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  opacity: 0;
  transition: opacity 0.15s;

  .relacion-selected-employee:hover & {
    opacity: 1;
  }
}

.relacion-empty-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  padding: 1rem 0;

  .icon {
    opacity: 0.4;
  }
}

.relacion-evaluators-list {
  overflow-y: auto;
}

.modal-card-foot.relacion-footer {
  background: #fff !important;
  border-top: 1px solid #ededed !important;
  padding: 0.85rem 1.5rem !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex-shrink: 0;
}

.relacion-hint {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-left: 0.5rem;

  .icon {
    color: #b5b5b5;
  }
}

@media (max-width: 768px) {
  .relacion-modal-card {
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
    margin: 0 !important;
  }

  .modal-card-body.relacion-body > .columns {
    height: auto;
  }

  .relacion-left-col,
  .relacion-right-col {
    height: auto;
    overflow: visible;
  }

  .modal-card-foot.relacion-footer {
    flex-direction: column !important;
    align-items: flex-start !important;

    .relacion-hint {
      margin-left: 0;
      margin-top: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalCreateRelacion.vue